import {
  Typography,
  Grid,
} from '@mui/material';
import HeroImage from './HeroImage';

export default function Hero(props) {
  const wipPages = [];
  let wip = wipPages.includes(props.name);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ height: "100vh" }}
      className="hero"
    >
      <Typography
        className="title"
        variant="h1"
      >
        {props.name}
      </Typography>
      {wip ? <Typography
        className="wip"
        variant="h2"
      >
        (coming soon!)
      </Typography> : <></>}
      <HeroImage imageS={props.imageS} imageL={props.imageL} />
    </Grid>
  );
}